import { render, staticRenderFns } from "./recommendPosition.vue?vue&type=template&id=3fabcbde&scoped=true&"
import script from "./recommendPosition.vue?vue&type=script&lang=js&"
export * from "./recommendPosition.vue?vue&type=script&lang=js&"
import style0 from "./recommendPosition.vue?vue&type=style&index=0&id=3fabcbde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fabcbde",
  null
  
)

export default component.exports